export function getFileInputValue({ current }: React.RefObject<HTMLInputElement | null>) {
  if (current && current.files?.length) {
    if (current.multiple) {
      return Array.from(current.files!);
    }
    return current.files![0];
  }
  return null;
}
